import Backbone from 'backbone'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import OnOffToggle from 'scoreboard/components/on-off-toggle'
import orFilterTemplate from './or-filter.hbs'
import ReportFilterBadges from './report-filter-badges'
import assignLinkGroups from 'scoreboard/components/assign-link-groups'

const OrFilter = Backbone.View.extend({

	/**
	 * The "OR" option for a report filter
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 * @param {String} options.filterKey the key associated with the report filter that this "OR" option is being
	 * generated for
	 * @param {Object} options.filter the filter this "OR" option is being generated for
	 * @param {Object} options.filters the report filter object containing all filters being displayed
	 */
	initialize: function(options = {}) {
		this.options = options
		this.filter = _.cloneDeep(this.options.filter || {})
		this.filters = _.cloneDeep(this.options.filters || [])
	},

	render: function() {
		// flatten all the filter values into a single array, used to check if we have anything to OR against
		let filterValues = _(this.filters).values().flatMap().value()

		//ensure linkGroups assigned
		this.maxLinkGroup = assignLinkGroups(filterValues)

		//ensure current filter has an or group assigned, this would be case if the filter is new
		if (_.isNil(this.filter.linkGroup)) {
			this.filter.linkGroup = this.maxLinkGroup++
		}

		// determine if the filter is in an existing or group
		let inLinkGroup = this.filter && _.find(filterValues, f =>
			!_.isEqual(f, this.filter) &&
			f.linkGroup == this.filter.linkGroup &&
			!_.isNil(f.linkGroup))

		if (!inLinkGroup) {
			// if the filter being edited isn't in an existing or group, exclude it
			// from the filters displayed by filter-badges
			let filtersWithoutCurrent = _.filter(filterValues, val => {
				return !_.isEqual(val, this.filter)
			})
			if (filtersWithoutCurrent.length == 0) {
				//if nothing left to choose from, nothing to render
				return this
			}
			this.filters[this.options.filterKey] = _.filter(this.filters[this.options.filterKey], val => {
				return !_.isEqual(val, this.filter)
			})
		}

		//figure out the or group of the filter if the "OR" grouping is toggled off.  If the filter is currently
		//a part of an "OR" group, assign it a new grouping containing just itself.  If the filter is NOT currently
		//in an "OR" grouping use it's previously assigned group
		this.linkGroupWhenToggledOff = inLinkGroup ? this.maxLinkGroup++ : this.filter.linkGroup

		this.$el.html(orFilterTemplate())
		this.chooseFilterToggle && this.chooseFilterToggle.remove()
		this.chooseFilterToggle = new OnOffToggle({
			name: 'chooseFilterToggle',
			checked: inLinkGroup,
			label: i18n.get('datasets.orGroup.toggle'),
			el: this.$('.choose-filter-toggle')
		}).render()

		this.chooseFilterToggle.on('change', () => {
			let isOn = this.chooseFilterToggle.val()
			this.$('.choose-filter').toggleClass('is-not-displayed', !isOn)
			if (isOn) {
				this._applyLinkGrouping()
				this.filterBadges.el.scrollIntoView()	//#16714
 			} else {
				this.filter.linkGroup = this.linkGroupWhenToggledOff
			}
			this.trigger('toggle', isOn)
		})


		this.filterBadges && this.filterBadges.remove()
		this.filterBadges = new ReportFilterBadges({
			defaultSelect: true,
			selected: inLinkGroup ? this.filter : null,
			filters: this.filters,
			isEditable: false,
			el: this.$('.choose-filter .panel-content'),
			meta: this.options.meta
		}).render()

		this.listenTo(this.filterBadges, 'click', e => {
			this._applyLinkGrouping()
			this.trigger('change', this.filter.linkGroup)
		})

		// AFTER everything is already setup, check the toggle state
		this.chooseFilterToggle.trigger('change')

		return this
	},

	_applyLinkGrouping: function() {
		let filterGrouping = this.filterBadges.selected()
		this.filter.linkGroup = null
		if (filterGrouping.length) {
			this.filter.linkGroup = filterGrouping[0].linkGroup
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.chooseFilterToggle, this.filterBadges], 'remove')
	}

})

export default OrFilter

OrFilter.__filename__ = 'reports/common/filter/or-filter.js'
